import CloseIcon from '@mui/icons-material/Close';
import { Box, FormControlLabel, IconButton, Modal, Stack, Switch, Typography } from '@mui/material';
import { CSSProperties, PropsWithChildren, ReactNode } from 'react';
import { MenuOption } from 'shared/types';
import { DropdownMenu } from '../DropdownMenu';

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxSizing: 'border-box',
    boxShadow: 24,
    p: 0.5,
    m: 0,
};

export const headerStyle = {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'primary.main',
    color: 'white',
    fontWeight: '700',
    padding: '0.25rem',
};

type MassActionToolbarProps = {
    menuOptions: MenuOption[];
    selectedMassActionType: string;
    title?: string;
    isOpen: boolean;
    disabled: boolean;
    disabledSelectAllButton?: boolean;
    allowSelectAll?: boolean;
    allRowsSelected?: boolean;
    customSelectAll?: ReactNode;
    switchContainerStyles?: CSSProperties;
    handleAllRowsSelected?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleOpen: () => void;
    handleClose: () => void;
};

export const SectionHeader = ({ title, children }: PropsWithChildren<{ title?: string }>) => (
    <Box sx={headerStyle}>{title ? title : children}</Box>
);

export function MassActionToolbar({
    isOpen,
    allowSelectAll,
    disabled,
    disabledSelectAllButton,
    handleClose,
    menuOptions,
    customSelectAll,
    children,
    title,
    switchContainerStyles,
    handleAllRowsSelected,
    selectedMassActionType,
}: PropsWithChildren<MassActionToolbarProps>) {
    return (
        <>
            {allowSelectAll && (
                <div key={'select-all-mass-actions'} style={switchContainerStyles}>
                    {customSelectAll || (
                        <FormControlLabel
                            control={<Switch onChange={handleAllRowsSelected} disabled={disabledSelectAllButton} />}
                            label='Select All'
                        />
                    )}
                </div>
            )}
            <DropdownMenu
                key={'dropdown-mass-actions'}
                title={title || 'Mass actions'}
                disabled={disabled}
                menuOptions={menuOptions}
            />
            <Modal
                open={isOpen}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Stack sx={modalStyle}>
                    <SectionHeader>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                gap: 6,
                                p: 1,
                            }}
                        >
                            <Typography variant={'h5'}>{selectedMassActionType}</Typography>
                            <IconButton onClick={handleClose}>
                                <CloseIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </SectionHeader>
                    <Stack sx={{ p: 4, gap: 2 }}>{children}</Stack>
                </Stack>
            </Modal>
        </>
    );
}
